import { ContentButton } from '../content/button';
import { ContentIntro } from '../content/intro';

/**
 * Model definition for BruttoNettoCalculator
 */
export interface BruttoNettoCalculator {
  __component: 'forms.brutto-netto-calculator';
  id: string;
  intro?: ContentIntro;
  cta?: ContentButton;
  salary: number;
  period: string;
  province: string;
  taxClass: string;
  childAllowance: string;
  churchTax: boolean;
  healthInsurance: string;
  healthInsuranceContributionRate: number;
  monthlyPrivateInsurance: number;
  employerCapitalFormingBenefit: number;
  occupationalPension: number;
}

export function isBruttoNettoCalculator(obj: { __component?: string }): obj is BruttoNettoCalculator {
  return obj.__component === 'forms.brutto-netto-calculator';
}
